import React, { useMemo } from 'react';
import { ITooltipParams } from 'ag-grid-community';
import { DollarCircleOutlined, InfoCircleFilled, WalletOutlined } from '@ant-design/icons';
import { Alert, AlertTitle, Grid, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { useCommissionsForMcaQuery } from '../../graphql/types';
import { useTheme } from '@mui/material/styles';

const McaCommissionsTooltip = (props: ITooltipParams & { mca: { id: string } }) => {
  const { mca } = props;
  const theme = useTheme();

  const { loading, data, refetch } = useCommissionsForMcaQuery({
    variables: { mcaId: mca.id },
    fetchPolicy: 'network-only'
  });

  const listItems = useMemo(() => {
    if (!data) return null;

    const items = data.commissionsForMca.map((commission, index) => (
      <ListItem key={commission.id} dense sx={{ py: 0 }}>
        <ListItemIcon>
          <DollarCircleOutlined style={{ color: '#237804' }} />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography
              color="secondary"
              sx={{
                width: 130,
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {commission.comment}
            </Typography>
          }
        />
        <ListItemText
          primary={
            <Typography color="secondary" sx={{ width: 50 }}>
              {'$' + commission.amount}
            </Typography>
          }
        />
        <ListItemSecondaryAction>
          <WalletOutlined
            twoToneColor={commission.isPaid ? theme.palette.success.main : theme.palette.error.main}
            style={{ color: commission.isPaid ? theme.palette.success.main : theme.palette.error.main }}
          />
        </ListItemSecondaryAction>
      </ListItem>
    ));

    if (loading) return <div>Loading...</div>;

    return (
      <Alert
        variant="border"
        color="info"
        icon={false}
        sx={{ width: '280px', border: 'none', backgroundColor: 'info', boxShadow: 'none', outline: 'none', p: 0.5, pb: 2 }}
      >
        <Grid container alignItems="center" sx={{ pl: 2, pt: 2 }}>
          <InfoCircleFilled style={{ color: '#706CE6', marginRight: 8 }} />
          <AlertTitle sx={{ m: 0, display: 'inline-flex', alignItems: 'center', pl: 0 }}>Commissions</AlertTitle>
        </Grid>
        <Grid container sx={{ px: 2, pt: 1 }}>
          <Grid item xs={12}>
            <List component="nav" aria-label="Commissions List" dense sx={{ py: 0 }}>
              {items}
            </List>
          </Grid>
        </Grid>
      </Alert>
    );
  }, [data, loading]);

  return listItems;
};

export default McaCommissionsTooltip;
